import getAccountData from "../../transport/accountData.js";
import noop from "../../lib/core/functional/noop";
import curry from "../../lib/core/functional/curry";

function onModule(mod) {
    return mod.default;
}

function isAccountTechnical(data) {
    const { profile } = data;

    return profile && profile.type_name && profile.type_name.toLowerCase() === "technical";
}

function loadIfTechnical(isTechnical) {
    return isTechnical ? import("./renderer").then(onModule) : Promise.resolve(noop);
}

const renderWithContext = curry(function renderWithContext(context, mod) {
    mod(context);
});

export default function loadTechnicalHelpers(context) {
    getAccountData()
        .then(isAccountTechnical)
        .then(loadIfTechnical)
        .then(renderWithContext(context))
        .catch(console.error);
    return context;
}
